import Filter from "../../../../../Plugins/Ems.Components/Resources/Private/Components/Atoms/Filter/Filter";

import AccordionItem from "../../../../../Plugins/Ems.Components/Resources/Private/Components/Molecules/AccordionItem/AccordionItem";
import JobList from "../../../../../Plugins/Ems.Components/Resources/Private/Components/Molecules/JobList/JobList";
import JobDetail from "../../../../../Plugins/Ems.Components/Resources/Private/Components/Molecules/JobDetail/JobDetail";
import Consultant from "../../../../../Plugins/Ems.Components/Resources/Private/Components/Molecules/Consultant/Consultant";
import ProfileFilter from "../../../../../Plugins/Ems.Profile/Resources/Private/Components/Organisms/Profile";
import RandomImage from "../../../../../Plugins/Ems.Components/Resources/Private/Components/Molecules/RandomImage/RandomImage";
import Slider from "../../../../../Plugins/Ems.Components/Resources/Private/Components/Molecules/Slider/Slider";
import TeaserList from "../../../../../Plugins/Ems.Components/Resources/Private/Components/Molecules/TeaserList/TeaserList";

import Header from "../../../../../Plugins/Ems.Components/Resources/Private/Components/Organisms/Header/Header";

import Form from "../Fusion/NodeTypes/Form/Form";

import TrackingInfo from "../../../../../Plugins/Ems.Components/Resources/Private/Components/Molecules/TrackingInfo/TrackingInfo";

Filter();

AccordionItem();
JobList();
JobDetail();
Consultant();
ProfileFilter();
RandomImage();
Slider();
TeaserList();

Header();

Form();

window.trackingInfo = TrackingInfo();
window.trackingInfo().init();

let equalColumnHeightTimer = null;
let equalColumnHeight = () => {
	clearTimeout(equalColumnHeightTimer);
	equalColumnHeightTimer = setTimeout(() => {
		let allDiffs = [];
		Array.from(document.querySelectorAll('.two-columns, .three-columns, .four-columns, .five-columns'), (multicolumn) => {
			try {
				let diffs = [];
				let largestDiff = 0;
				let elementIndex = multicolumn.getAttribute('data-equal-height-element-index');
				Array.from(multicolumn.childNodes).forEach((column) => {
					if (column.childNodes.length <= elementIndex) {
						return;
					}

					column.childNodes[elementIndex].style.paddingTop = 'auto';

					let diff = column.childNodes[elementIndex].offsetTop - column.childNodes[elementIndex].parentNode.offsetTop;
					largestDiff = Math.max(largestDiff, diff);
					diffs.push({
						element: column.childNodes[elementIndex],
						diff: diff
					});
				});
				if (diffs && diffs.length > 0) {
					allDiffs.push({columns: diffs, max: largestDiff});
				}
			} catch (e) {
				// ignore..
			}
		});

		if (window.innerWidth >= 768) {
			Array.from(allDiffs).forEach((multicolumn) => {
				Array.from(multicolumn.columns).forEach((column) => {
					column.element.style.paddingTop = (multicolumn.max - column.diff) + 'px';
				});
			});
		}
	}, 200);
};
equalColumnHeight();
window.addEventListener('resize', equalColumnHeight);
